import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { EntityRatingCommentCount, Professional, Rating } from '@medprev-web-app/api-graphql-client';
import { ReactNode } from 'react';

import { ProfessionalProfileActions } from './professional-profile-actions.component';

import { EntityRating } from '@/app/(main)/(pages)/_components/entities/entity-rating-sumary.component';
import { professionalDisplayName } from '@/utils/formatters/professional-name';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { EntityTypeEnum } from '@/types/enums/entity-type.enum';
import { EntityAvatar } from '@/components/ui/avatar/entity-avatar';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface ProfessionalHeaderProps {
  professional: Professional;
  commentsCount?: EntityRatingCommentCount | null;
  shouldAddLightbox?: boolean;
  specialties?: ReactNode;
  scheduleAction?: ReactNode;
}

export function ProfessionalHeader({
  professional,
  commentsCount,
  shouldAddLightbox = false,
  specialties,
  scheduleAction,
}: ProfessionalHeaderProps) {
  return (
    <>
      <div
        className="flex flex-col items-center gap-4 pb-6 min-[768px]:flex-row min-[768px]:items-start"
        data-testid={DataTestIdEnum.PROFESSIONAL_PROFILE_HEADER}
      >
        <EntityAvatar
          src={professional.avatar as string}
          size="xxxl"
          alt={`Foto de perfil de ${professional.name}`}
          shouldAddLightbox={shouldAddLightbox}
          type={EntityTypeEnum.PROFESSIONAL}
          dataTestId={professional.avatar
            ? DataTestIdEnum.PROFESSIONAL_PROFILE_AVATAR
            : DataTestIdEnum.PROFESSIONAL_PROFILE_AVATAR_DEFAULT}
          data-analytics-event={AnalyticsEnum.PROFESSIONAL_PROFILE_CLICK_AVATAR}
        />

        <div className="flex flex-col gap-2">
          <Typography
            variant={TypographyVariant.MODAL_TITLE}
            as="h1"
            className="text-center min-[768px]:text-left break-words text-wrap hyphens-auto overflow-hidden"
          >
            {professionalDisplayName({ honorific: professional.honorific ?? '', name: professional.name ?? '' })}
          </Typography>

          <div className="text-center min-[768px]:text-left">
            {specialties}
          </div>
        </div>
      </div>

      <EntityRating
        rating={professional.rating as Rating}
        commentsCount={commentsCount}
        data-analytics-event={AnalyticsEnum.PROFESSIONAL_PROFILE_CLICK_REVIEWS_WITH_COMMENT}
      />

      <div className="py-4">
        <ProfessionalProfileActions professional={professional} scheduleAction={scheduleAction} />
      </div>
    </>
  );
}
